import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    gridArea: 'topbar',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.custom.background.area,
    minHeight: theme.spacing(8),
    borderBottom: `solid 1px ${theme.palette.divider}`,
    overflow: 'hidden',

    '& .text-title': {
      '&-container': {
        flexGrow: 1,
        overflow: 'hidden',
      },
      '&-course': {
        color: theme.palette.text.hint,
      },
      '&-title': {
        color: theme.palette.text.primary,
      },
    },

    '& .pagination': {
      display: 'flex',
      alignItems: 'center',
      padding: `0 ${theme.spacing(1)}px`,

      '&-text': {
        margin: `0 ${theme.spacing(1)}px`,
        color: theme.palette.text.hint,
      },
      '&-next, &-back': {
        color: theme.palette.text.hint,
      },
    },

    '& .btn-print': {
      marginRight: theme.spacing(3),
    },

    '& .btn-conclusion': {
      padding: `0 ${theme.spacing(3)}px`,
      borderLeft: `solid 1px ${theme.palette.divider}`,
      color: theme.palette.text.hint,

      '&:not(.completed)': {
        '& .btn-conclusion': {
          '&-icon, &-text': {
            color: theme.palette.primary.main,
          },
        },
      },
      '&.completed': {
        '& .btn-conclusion': {
          '&-icon, &-text': {
            color: theme.palette.custom.feedback.positive,
          },
        },
      },
      '&-icon': {
        marginLeft: theme.spacing(1),
      },
      '&-text': {
        fontWeight: theme.typography.fontWeightMedium,
        lineHeight: 1.2,
      },
    },

    [theme.breakpoints.up('md')]: {
      '& .btn-icon-right-wrapper': {
        margin: `0 ${theme.spacing(2)}px`,
      },

      '& .btn-conclusion': {
        height: '100%',
      },
    },

    [theme.breakpoints.down('sm')]: {
      '&:not(.with-certificate)': {
        flexWrap: 'wrap',
        minHeight: theme.spacing(12),
      },
      [`& .btn-icon-right-wrapper,
        & .btn-toggle-sidemenu`]: {
        margin: `0 ${theme.spacing(2)}px`,
      },

      '& .text-title': {
        '&-container': {
          width: `calc(100% - (${theme.spacing(9)}px * 2))`,
          height: theme.spacing(6),
          display: 'flex',
          alignItems: 'center',
        },
        '&-title': {
          ...theme.typography.caption,
        },
      },

      '& .btn-print': {
        order: 2,
        margin: 0,
      },

      '& .btn-toggle-sidemenu': {
        order: 3,
      },

      [`& .pagination,
        & .btn-conclusion`]: {
        height: theme.spacing(6),
        borderTop: `solid 1px ${theme.palette.divider}`,
      },

      '& .pagination': {
        order: 4,
        flexGrow: 1,
      },

      '& .btn-conclusion': {
        order: 5,
        maxWidth: 'calc(100% - 180px)',
      },
    },
  },
}));

export default styles;
